/**
 * 集計グラフの「評価の見分け方」凡例 (docs/27 §9-3)。
 *
 * 2026-09-16 (オーナー指示): グラフの下にあるとスクロールしないと見えないため、グラフの上
 * (エリア / 路線の色分けの凡例のすぐ下) に置く。並び順は POLARITY_DISPLAY_ORDER に従う。
 */
import { POLARITY_LABELS, type EvaluationPolarity } from '@citizen-walk/shared-types';
import {
  barFill,
  barFillBackgroundSize,
  POLARITY_DISPLAY_ORDER,
  POLARITY_HATCH_DESCRIPTIONS,
} from './barFillStyles';

export interface PolarityLegendProps {
  /** 色が何を表すかの補足 (例「色は調査項目を表します。」)。 */
  colorNote?: string;
  className?: string;
  /** 評価の区分の表示名 (評価の定義の `polarityLabels`。無ければ既定の名前)。 */
  polarityLabels?: Record<EvaluationPolarity, string>;
}

export function PolarityLegend({
  colorNote,
  className = '',
  polarityLabels = POLARITY_LABELS,
}: PolarityLegendProps) {
  return (
    <p
      className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-slate-500 ${className}`.trim()}
    >
      <span>評価の見分け方:</span>
      {POLARITY_DISPLAY_ORDER.map((k) => (
        <span key={k} className="flex items-center gap-1">
          <span
            className="inline-block h-3 w-5 rounded-sm border border-slate-300"
            style={{ ...barFill('#475569', k), backgroundSize: barFillBackgroundSize(k) }}
          />
          {polarityLabels[k]}（{POLARITY_HATCH_DESCRIPTIONS[k]}）
        </span>
      ))}
      {colorNote && <span>{colorNote}</span>}
    </p>
  );
}
